setInterval(function(){
		const cartCountBubble = document.querySelector('.cart-count-bubble')
		// console.log(cartCountBubble.textContent)
		if(cartCountBubble.textContent == '(0)'){
			cartCountBubble.style.display="none";
		} else {
			cartCountBubble.style.display="inline";
		}
	}, 1000);










